import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { useI18n } from "@/i18n";
import { cvUrl } from "@/lib/api";
import { scrollToSection } from "@/components/Header";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-line bg-panel px-6 py-12 md:px-10 xl:px-16" data-testid="footer">
      <div className="mx-auto flex max-w-[1440px] flex-col items-start justify-between gap-8 md:flex-row md:items-center">
        <div className="flex items-center gap-3">
          <Logo size={26} />
          <div className="text-xs tracking-[0.25em] text-zinc-400">CALEB DEMISEW ZELEKE — {t.role}</div>
        </div>
        <nav className="flex flex-wrap items-center gap-6 text-[11px] tracking-[0.25em] text-zinc-500">
          <a href="#about" data-testid="footer-nav-about" onClick={(e) => { e.preventDefault(); scrollToSection("#about"); }} className="transition-colors duration-200 hover:text-gold">{t.nav.about}</a>
          <a href="#skills" data-testid="footer-nav-skills" onClick={(e) => { e.preventDefault(); scrollToSection("#skills"); }} className="transition-colors duration-200 hover:text-gold">{t.nav.skills}</a>
          <a href="#projects" data-testid="footer-nav-projects" onClick={(e) => { e.preventDefault(); scrollToSection("#projects"); }} className="transition-colors duration-200 hover:text-gold">{t.nav.projects}</a>
          <a href="#contact" data-testid="footer-nav-contact" onClick={(e) => { e.preventDefault(); scrollToSection("#contact"); }} className="transition-colors duration-200 hover:text-gold">{t.nav.contact}</a>
          <a href={cvUrl()} target="_blank" rel="noreferrer" download="CALEB_DEMISEW_ZELEKE_CV.pdf" data-testid="footer-cv-link" className="text-gold transition-colors duration-200 hover:text-white">CV</a>
          <Link to="/admin" data-testid="footer-admin-link" className="transition-colors duration-200 hover:text-gold">{t.footer.admin}</Link>
        </nav>
      </div>
      <div className="mx-auto mt-10 flex max-w-[1440px] flex-col items-start justify-between gap-3 border-t border-white/5 pt-6 text-[10px] tracking-[0.25em] text-zinc-600 md:flex-row md:items-center">
        <span>© 2026 CALEB DEMISEW ZELEKE</span>
        <span className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-green-500" />
          {t.footer.tagline}
        </span>
        <span>{t.footer.built}</span>
      </div>
    </footer>
  );
}
